var exports = {
  "a": "DesktopDownloadNagbar.module__platformIcons___cXRCc2",
  "t": "DesktopDownloadNagbar.module__platformIcon___cXRCc2",
};

module.exports = exports;
